import { ChangeDetectionStrategy, Component, viewChild } from '@angular/core';
import { ProjectBaseScenarioTabItemComponent } from 'app/cem/project/content/project-base-scenario-tabitem.component';
import { ProjectResourceItemsComponent } from '../../resources/project-resource-items/project-resource-items.component';

@Component({
  selector: 'app-project-resources',
  templateUrl: './project-resources.component.html',
  styleUrls: ['./project-resources.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    ProjectResourceItemsComponent,
  ],
})
export class ProjectResourcesComponent extends ProjectBaseScenarioTabItemComponent {

  readonly projectResourceItemsComponent = viewChild(ProjectResourceItemsComponent);

  constructor() {
    super();
  }

  public runTabActivity(): void {
    this.projectResourceItemsComponent().refreshStandardConfiguration();
  }

}